'use client';

import { useEffect, useState, useTransition } from 'react';
import { useRouter } from 'next/navigation';
import { disableDraftMode } from '../actions/disableDraftMode';
import { useDraftModeEnvironment } from 'next-sanity/hooks';

export function DisableDraftMode() {
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  const [isClient, setIsClient] = useState(false);

  const disable = () => {
    return startTransition(async () => {
      await disableDraftMode();
      router.refresh();
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsClient(true);
    }
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <div className="fixed bottom-px right-px z-10">
      <button
        type="button"
        onClick={disable}
        disabled={pending}
        className="text-white m-3 rounded-md bg-slate-900 p-2.5 text-sm font-semibold shadow-2xl hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-600"
      >
        {pending ? <span>Disabling draft mode...</span> : <span>Disable draft mode</span>}
      </button>
    </div>
  );
}
